module.exports = __webpack_public_path__ + "img/h_postcard-back.8c32ffd1.png";